export enum SlimNavActionTypes {
  SLIM_NAV_UPDATE_AIRPORTS = 'SLIM_NAV_UPDATE_AIRPORTS',
  SLIM_NAV_UPDATE_DATES = 'SLIM_NAV_UPDATE_DATES'
}
